import "./TitleRegistration.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { createTheme, ThemeProvider } from "@mui/material";

const theme = createTheme({
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: "#f2f2f2", // Background color for options list
          boxShadow: "0 2px 8px 1px rgb(0, 0, 0, 0.15)",
        },
        option: {
          "&.Mui-focused": {
            backgroundColor: "rgb(0, 0, 0, 0.2)", // Hover color for options
            boxShadow: "0 2px 8px 1px rgb(0, 0, 0, 0.15)",
          },
          "&:hover": {
            backgroundColor: "rgb(0, 0, 0, 0.5)", // Default hover background
            boxShadow: "0 2px 8px 1px rgb(0, 0, 0, 0.15)",
          },
          "&:active": {
            backgroundColor: "rgb(0, 0, 0, 0.6)", // Default hover background
            boxShadow: "0 2px 8px 1px rgb(0, 0, 0, 0.15)",
          },
          "&:selected": {
            backgroundColor: "rgb(0, 0, 0, 0.9)", // Default hover background
            boxShadow: "0 2px 8px 1px rgb(0, 0, 0, 0.15)",
          },
        },
      },
    },
  },
});
const options = ["Option 1", "Option 2", "Option 3", "Option 4"];

const TitleRegistration = () => {
  return (
    <section className="title-registration-page">
      <h1>Register Your Title</h1>

      {/* form part one */}
      <form className="form-container form-1">
        <div className="flex-container">
          <div>
            <label style={{ paddingBottom: "0.5rem" }}>Owner Name</label>
            <TextField
              id="outlined-controlled"
              label="Enter Owner Name"
              fullWidth

              // value={name}
              // onChange={(e) => {
              //   setName(e.target.value);
              // }}
            />

            <label style={{ marginTop: "3rem", marginBottom: "0.5rem" }}>
              Enter Description
            </label>
            <textarea
              rows="7"
              cols="40"
              placeholder="Enter Description"
            ></textarea>
          </div>
          <div>
            <label>Frequency</label>
            <ThemeProvider theme={theme}>
              <Autocomplete
                disablePortal
                options={options}
                sx={{
                  width: 300,
                  paddingTop: 1,
                  paddingBottom: 3,
                  marginBottom: 3,
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Frequency" />
                )}
              />
            </ThemeProvider>

            <label>Category</label>
            <ThemeProvider theme={theme}>
              <Autocomplete
                disablePortal
                options={options}
                sx={{
                  width: 300,
                  paddingTop: 1,
                  paddingBottom: 3,
                  marginBottom: 3,
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Category" />
                )}
              />
            </ThemeProvider>

            <label>Frequency</label>
            <ThemeProvider theme={theme}>
              <Autocomplete
                disablePortal
                options={options}
                sx={{
                  width: 300,
                  paddingTop: 1,
                  paddingBottom: 3,
                  marginBottom: 3,
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Frequency" />
                )}
              />
            </ThemeProvider>
          </div>
          <div>
            <label>State</label>
            <ThemeProvider theme={theme}>
              <Autocomplete
                disablePortal
                options={options}
                sx={{
                  width: 300,
                  paddingTop: 1,
                  paddingBottom: 3,
                  marginBottom: 3,
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select State" />
                )}
              />
            </ThemeProvider>
            <label>District</label>
            <ThemeProvider theme={theme}>
              <Autocomplete
                disablePortal
                options={options}
                sx={{
                  width: 300,
                  paddingTop: 1,
                  paddingBottom: 3,
                  marginBottom: 3,
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select District" />
                )}
              />
            </ThemeProvider>
            <label>Language</label>
            <ThemeProvider theme={theme}>
              <Autocomplete
                disablePortal
                options={options}
                sx={{
                  width: 300,
                  paddingTop: 1,
                  paddingBottom: 3,
                  marginBottom: 3,
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Language" />
                )}
              />
            </ThemeProvider>
          </div>
        </div>
        <div className="next-button-container">
          <button>NEXT </button>
        </div>
      </form>
    </section>
  );
};

export default TitleRegistration;
